import {connect} from 'react-redux';
import Maintenance from './Maintenance.jsx';
import {handleMaintenanceComplete} from './actions';

const mapStateToProps = state => ({
  maintenanceMessage: state.shared.auth.maintenanceMessage
});

const mapDispatchToProps = dispatch => ({
  onMaintenanceComplete: data => dispatch(handleMaintenanceComplete(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Maintenance);


// WEBPACK FOOTER //
// ./src/features/shared/auth/MaintenanceContainer.jsx